/**
 * QR of the pairing code. It encodes the deep URL
 * (`https://…/receive?code=ENVR1-XXXXX`) so that ANY camera (the system
 * one or the in-app scanner) opens the receive page with the code already set.
 *
 * It is ALWAYS painted on a white chip with black modules (logo
 * theme-safe pattern): many readers do not decode an inverted QR, so
 * contrast cannot depend on the theme.
 */

import { createMemo } from "solid-js";
import { encode } from "uqr";

export function QrCode(props: { payload: string; class?: string }) {
  const qr = createMemo(() => encode(props.payload, { ecc: "M", border: 2 }));

  const path = createMemo(() => {
    const { data } = qr();
    const parts: string[] = [];
    for (let y = 0; y < data.length; y += 1) {
      const row = data[y];
      if (!row) {
        continue;
      }
      for (let x = 0; x < row.length; x += 1) {
        if (row[x]) {
          // oxlint-disable-next-line lingui/no-unlocalized-strings -- SVG path, not copy
          parts.push(`M${x} ${y}h1v1h-1z`);
        }
      }
    }
    return parts.join("");
  });

  return (
    <div class={`inline-flex rounded-xl bg-white p-2 shadow-sm ${props.class ?? ""}`}>
      <svg
        viewBox={`0 0 ${qr().size} ${qr().size}`}
        class="h-full w-full"
        role="img"
        aria-label="QR"
        data-testid="qr-code"
        data-qr-payload={props.payload}
        shape-rendering="crispEdges"
      >
        <path d={path()} fill="#000000" />
      </svg>
    </div>
  );
}
